import { Field, Text as SitecoreText } from '@sitecore-jss/sitecore-jss-nextjs';
import React from 'react';
import { classnames, TArg, TTailwindString } from 'tailwindcss-classnames';
import useExperienceEditor from 'lib/sitecore/use-experience-editor';
import { ValidHeadingLevels } from 'lib/sitecore/component-params';

const CALLOUT_PREVIEW_CHAR_LIMIT = 28;

type HeadingCalloutProps = {
  calloutText?: Field<string>;
  headingAlignClassName?: TTailwindString | TArg;
  editable?: boolean;
  headingLevel?: ValidHeadingLevels;
};

const HeadingCallout = ({
  calloutText,
  headingAlignClassName,
  editable = true,
  headingLevel,
}: HeadingCalloutProps): JSX.Element | null => {
  const isExperienceEditor = useExperienceEditor();

  const showCallout =
    headingLevel === 'h2' && (!!calloutText?.value?.trim()?.length || isExperienceEditor);

  if (!showCallout) {
    return null;
  }
  const calloutClasses = classnames(
    'font-bold',
    'text-base',
    'md:text-body',
    'leading-4',
    'tracking-[0.08em]',
    'uppercase',
    'mb-2',
    'md:mb-4',
    headingAlignClassName
  );

  return (
    <div
      className={calloutClasses}
      data-component="helper/heading-callout"
      data-testid="heading-callout-element"
    >
      {isExperienceEditor ? (
        <SitecoreText field={calloutText} editable={editable} />
      ) : (
        calloutText?.value?.slice(0, CALLOUT_PREVIEW_CHAR_LIMIT)
      )}
    </div>
  );
};

export default HeadingCallout;
